import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CognitoAuthService} from '../../shared/auth/cognito.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    providers: [CognitoAuthService]
})
export class ForgotPasswordComponent implements OnInit {

    email: string;
    code: string;
    newPassword: string;
    confirmPassword: string;

    errorMessage: string;
    resetPasswordCodeSent: boolean;
    resendVerificationCode: boolean;

    constructor(private router: Router, private authService: CognitoAuthService) {
        this.email = '';
        this.code = '';
        this.newPassword = '';
        this.confirmPassword = '';

        this.errorMessage = '';
        this.resetPasswordCodeSent = false;
        this.resendVerificationCode = false;
    }

    ngOnInit() {
        this.errorMessage = null;
    }

    requestCode(resend) {
        const self = this;

        if (typeof resend !== 'undefined') {
            this.resetPasswordCodeSent = resend;
            this.resendVerificationCode = true;
        }

        if (!this.resetPasswordCodeSent) {

            console.log('Requesting code...');

            this.resetPasswordCodeSent = true;

            this.authService.forgotPassword(this.email, {
                cognitoCallback: function (message, result) {
                    if (message) {
                        console.log('reset password failed');
                        this.errorMessage = message;
                        // we stay on this page and try again!
                    }
                }
            });
        } else {
            console.log('Updating password using the verification code');

            this.authService.confirmNewPassword(this.email, this.code, this.newPassword, {
                cognitoCallback: function (message, result) {
                    if (message) {
                        console.log('Password reset failed!');
                        // XXX: redirect somewhere else???
                    } else {
                        console.log('Password reset succeeded - redirecting to sign-in');
                        self.router.navigate(['/sign-in']);
                    }
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/containers/forgot-password/forgot-password.component.ts